// Central bilingual copy for the site.
export const copy = {
    nav: {
        story: { en: "Story", te: "మా కథ" },
        pickles: { en: "Pickles", te: "ఊరగాయలు" },
        shop: { en: "Shop", te: "షాప్" },
        process: { en: "Process", te: "తయారీ" },
        contact: { en: "Contact", te: "సంప్రదించండి" },
        faq: { en: "FAQs", te: "ప్రశ్నలు" },
        about: { en: "About", te: "గురించి" },
    },
    hero: {
        eyebrow: {
            en: "Est. Andhra Kitchen · Family Recipes Since 2000",
            te: "ఆంధ్ర వంటిల్లు · 2000 నుండి తరతరాల రుచులు",
        },
        line1: { en: "Pure", te: "పూర్తిగా" },
        line2: { en: "home-made,", te: "ఇంట్లోనే" },
        line3: { en: "hand-poured", te: "చేతితో" },
        line4: { en: "pickles.", te: "నానబెట్టిన" },
        line5: { en: "", te: "ఊరగాయలు." },
        sub: {
            en: "Sun-cured mangoes, cold-pressed oil, mother's hands. No preservatives — only patience.",
            te: "ఎండలో ఉంచిన మామిడికాయలు, ఘాణా నూనె, అమ్మ చేతి రుచి. కృత్రిమ పదార్థాలు లేవు — కేవలం సహనం.",
        },
        cta_shop: { en: "Shop the pickles", te: "ఊరగాయలు కొనండి" },
        cta_story: { en: "Read the story", te: "కథను చదవండి" },
    },
    marquee: {
        en: "Pure Home-Made · Authentic Andhra Recipes · 100% Natural · No Preservatives · స్వచ్ఛమైన రుచి · FSSAI Licensed · Made by Kumari Amma",
        te: "స్వచ్ఛమైన ఇంటి రుచి · అసలైన ఆంధ్ర వంటలు · 100% సహజం · కల్తీ లేకుండా · Pure Home-Made · కుమారి అమ్మ చేతి రుచి",
    },
    trust: {
        eyebrow: { en: "Why our pickles", te: "మా ఊరగాయలు ఎందుకు" },
        items: [
            { title: { en: "No Preservatives", te: "కల్తీ లేకుండా" }, body: { en: "Not a drop of chemistry. Salt, chili, oil, sun.", te: "కేవలం ఉప్పు, మిర్చి, నూనె, ఎండ." } },
            { title: { en: "Hand-Poured", te: "చేతితో తయారీ" }, body: { en: "Kumari Amma still tempers every batch herself.", te: "కుమారి అమ్మ స్వయంగా తయారు చేస్తారు." } },
            { title: { en: "Cold-Pressed Oil", te: "ఘాణా నూనె" }, body: { en: "Single-ghani cold-pressed oil from Guntur. Nothing else.", te: "గుంటూరు ఘాణా ఘాణా నూనె." } },
            { title: { en: "FSSAI Licensed", te: "FSSAI అనుమతి" }, body: { en: "Licensed. Certified. Home-scale, not factory-scale.", te: "అనుమతి పొందిన ఇంటి వంటగది." } },
        ],
    },
    categoryTiles: {
        eyebrow: { en: "The Shelves", te: "అరలు" },
        veg: {
            title: { en: "Veg", te: "శాకాహారం" },
            body: { en: "Avakaya, gongura, lemon, ginger and 13 more — the everyday packs.", te: "ఆవకాయ, గోంగూర, నిమ్మ, అల్లం, మరిన్ని 13." },
        },
        nonveg: {
            title: { en: "Non-Veg", te: "మాంసాహారం" },
            body: { en: "Chicken, mutton, prawn, fish — cured, cellared, patient.", te: "కోడి, మటన్, రొయ్యలు, చేపలు." },
        },
        gongura_veg: {
            title: { en: "Gongura Combo · Veg", te: "గోంగూర కాంబో · శాకా." },
            body: { en: "Ten sorrel-leaf pairings — velluli, ullipaya, avakaya, allam & more.", te: "పది గోంగూర కలయికలు — వెల్లుల్లి, ఉల్లి, ఆవకాయ, అల్లం." },
        },
        gongura_nonveg: {
            title: { en: "Gongura Combo · Non-Veg", te: "గోంగూర కాంబో · మాంసా." },
            body: { en: "Sorrel meets country meat — chicken, mutton, prawns, fish.", te: "గోంగూర + కోడి, మటన్, రొయ్యలు, చేపలు." },
        },
        gongura: {
            title: { en: "Gongura", te: "గోంగూర" },
            body: { en: "Fifteen sorrel pairings — vegetables, meats, seafood. Andhra's crown jewel.", te: "పదిహేను గోంగూర కలయికలు — కూరగాయలు, మాంసం, రొయ్యలు." },
        },
        sweet: {
            title: { en: "Sweet", te: "తీపి" },
            body: { en: "Sweet mango thokku — ripe fruit, jaggery, gentle spice.", te: "తీపి మామిడి తొక్కు — పండిన పండు, బెల్లం." },
        },
    },
    bestsellers: {
        eyebrow: { en: "The Household Favorites", te: "అందరికీ ఇష్టం" },
        title: { en: "Six pouches, six\nweekly regulars.", te: "ఆరు ప్యాకెట్లు, ఆరు\nవారపు అభిమానులు." },
    },
    products: {
        eyebrow: { en: "The Catalog · 40 Pickles", te: "మా జాబితా · 40 ఊరగాయలు" },
        title: {
            en: "Each pouch, a small\nheirloom.",
            te: "ప్రతి ప్యాకెట్,\nఒక స్మృతి.",
        },
        veg: { en: "Veg", te: "శాకాహారం" },
        nonveg: { en: "Non-Veg", te: "మాంసాహారం" },
        gongura_veg: { en: "Gongura Combo · Veg", te: "గోంగూర కాంబో · శాకా." },
        gongura_nonveg: { en: "Gongura Combo · Non-Veg", te: "గోంగూర కాంబో · మాంసా." },
        sweet: { en: "Sweet", te: "తీపి" },
        add: { en: "Add to Basket", te: "బాస్కెట్‌కు చేర్చు" },
        whatsapp: { en: "Order via WhatsApp", te: "వాట్సాప్‌లో ఆర్డర్" },
        view: { en: "View pack", te: "వివరాలు" },
        heat: { en: "Heat", te: "కారం" },
        talk: {
            en: "Any doubts? Talk to us before ordering — we'll help you pick.",
            te: "ఏవైనా సందేహాలు ఉన్నాయా? ఆర్డర్ ముందు మాతో మాట్లాడండి.",
        },
        customise: {
            en: "Ordering 1 kg or more? You can customise the spiciness — just tell us on WhatsApp.",
            te: "1 kg లేదా అంతకంటే ఎక్కువ ఆర్డర్? మీకు కావాల్సిన ఘాటు స్థాయిని WhatsApp లో చెప్పండి.",
        },
        spice_custom_note: {
            en: "Please call or WhatsApp us for any customisations required on spice levels —",
            te: "ఘాటు స్థాయిలో ఏవైనా మార్పులు కావాలంటే దయచేసి మాకు కాల్ చేయండి లేదా WhatsApp చేయండి —",
        },
        spice_labels: {
            mild: { en: "Mild", te: "తక్కువ" },
            medium: { en: "Medium", te: "మధ్యస్థం" },
            hot: { en: "Hot", te: "ఘాటు" },
        },
    },
    manifesto: {
        eyebrow: { en: "The Manifesto", te: "మా ప్రతిజ్ఞ" },
        title: {
            en: "Three rules,\nunchanged\nfor 25 years.",
            te: "25 ఏళ్ళుగా\nమారని\nమూడు నియమాలు.",
        },
        chapters: [
            {
                no: "01",
                title: { en: "The Sun.", te: "ఎండ." },
                body: {
                    en: "Every batch begins on the rooftop. Mangoes and spices cured for four days in Guntur-district sun. No shortcuts, no ovens.",
                    te: "ప్రతి బ్యాచ్ మేడపై మొదలవుతుంది. గుంటూరు జిల్లా ఎండలో నాలుగు రోజులు మామిడి, మసాలాలు.",
                },
            },
            {
                no: "02",
                title: { en: "The Oil.", te: "నూనె." },
                body: {
                    en: "Only cold-pressed oil from a single ghani in Guntur. Poured warm, sealed by hand, never rushed.",
                    te: "గుంటూరు ఘాణా తాజా ఘాణా నూనె. వెచ్చగా పోసి, చేతితో మూసేస్తాము — ఏ మాత్రం తొందర లేదు.",
                },
            },
            {
                no: "03",
                title: { en: "The Hands.", te: "చేతులు." },
                body: {
                    en: "Kumari garu still hand-mixes every batch herself. No factory, no line — just a kitchen, a family, and time.",
                    te: "కుమారి గారు స్వయంగా ప్రతి ప్యాకెట్ని చేతితో కలుపుతారు. ఫ్యాక్టరీ లేదు — ఒక వంటగది, ఒక కుటుంబం, తీరిక.",
                },
            },
        ],
    },
    testimonials: {
        eyebrow: { en: "In the words of…", te: "వారి మాటల్లో…" },
        items: [
            {
                quote: {
                    en: "Ordered 500g boneless chicken on a Tuesday, it reached Bengaluru Friday morning. Finished it in nine days. Slightly spicier than I expected — that's my problem, not theirs.",
                    te: "మంగళవారం 500g ఎముకలేని కోడి ఆర్డర్ చేశాను, శుక్రవారం ఉదయం బెంగళూరు చేరింది. తొమ్మిది రోజుల్లో అయిపోయింది. కొంచెం ఘాటుగా ఉంది — అది నా సమస్య, వాళ్ళది కాదు.",
                },
                name: { en: "Harika V.", te: "హారిక వి." },
                city: { en: "Bengaluru · Repeat customer", te: "బెంగళూరు · తిరిగి ఆర్డర్" },
            },
            {
                quote: {
                    en: "My father is 78 and very particular about avakaya. He asked me which shop in Guntur I bought it from. That is the highest compliment he gives anybody.",
                    te: "మా నాన్నకు 78 ఏళ్ళు, ఆవకాయ విషయంలో చాలా పట్టుదల. గుంటూరులో ఏ షాప్‌లో కొన్నావని అడిగారు. ఆయన ఇచ్చే అత్యున్నత ప్రశంస అదే.",
                },
                name: { en: "Srinivasa Rao M.", te: "శ్రీనివాసరావు ఎం." },
                city: { en: "Hyderabad", te: "హైదరాబాద్" },
            },
            {
                quote: {
                    en: "I courier this to my daughter in Melbourne every three months. Works out cheaper than her flying home because she missed gongura.",
                    te: "మా అమ్మాయికి మెల్‌బోర్న్‌కు మూడు నెలలకోసారి పంపుతాను. గోంగూర కోసం ఆమె ఇంటికి రావడం కంటే ఇది చౌక.",
                },
                name: { en: "Padmavathi K.", te: "పద్మావతి కె." },
                city: { en: "Guntur", te: "గుంటూరు" },
            },
        ],
    },
    contact: {
        eyebrow: { en: "Order & Reach Us", te: "ఆర్డర్ చేయండి · సంప్రదించండి" },
        title: {
            en: "One message,\nfresh from the\nkitchen.",
            te: "ఒక్క సందేశం,\nవంటగది నుండి\nతాజాగా.",
        },
        body: {
            en: "We take orders on WhatsApp — same phone, same family, same pickles. Ship pan-India in 3–5 days.",
            te: "వాట్సాప్‌లో ఆర్డర్ తీసుకుంటాము. భారతదేశ వ్యాప్తంగా 3–5 రోజుల్లో డెలివరీ.",
        },
        whatsapp: { en: "Message on WhatsApp", te: "వాట్సాప్‌లో మెసేజ్" },
        phone: { en: "Call the kitchen", te: "వంటగదికి ఫోన్" },
    },
    footer: {
        tagline: { en: "Made with Love in Guntur.", te: "గుంటూరులో ప్రేమతో తయారు." },
        rights: { en: "© Bheema's Kumari Pickles. All recipes belong to the family.", te: "© భీమాస్ కుమారి పికిల్స్. అన్ని రుచులు కుటుంబం సొంతం." },
        fssai: { en: "FSSAI Lic. No.", te: "FSSAI అనుమతి నం." },
        gst: { en: "GSTIN", te: "జీఎస్‌టీ" },
    },
};

// Business info — placeholders. Update these when real details are available.
export const BUSINESS = {
    // FSSAI licence + GSTIN pending from the client — kept empty so nothing renders.
    fssai: "",
    gst: "37ABGFK2698P1ZE",
    instagram: "https://instagram.com/kumaripickles",
    facebook: "https://facebook.com/kumaripickles",
    instagram_handle: "@kumaripickles",
    facebook_handle: "@kumaripickles",
    email: "kumaripickles99@gmail.com",
    phone_display: "+91 91000 05390",
    address: {
        en: "Prop. Bheema Kumari · 2-157, near Police Station, Durgi, Andhra Pradesh · 522612",
        te: "ప్రొ. భీమ కుమారి · 2-157, పోలీస్ స్టేషన్ దగ్గర, దుర్గి, ఆంధ్ర ప్రదేశ్ · 522612",
    },
    hours: {
        en: "Every day · 9 AM – 9 PM IST",
        te: "ప్రతిరోజూ · ఉదయం 9 – రాత్రి 9",
    },
};
